import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import router from './router'
import store from './store'
import qs from 'qs'
import VueMeta from 'vue-meta'
import './style/reset.css'
import './style/element-variables.scss'
import i18n from './components/language/index';
import VueScrollTo from 'v-scroll-to'
import waterfall from 'vue-waterfall2'

// 初始化Vue配置
Vue.config.productionTip = false;
Vue.use(VueMeta)
Vue.use(VueScrollTo)
Vue.use(waterfall);

//ElementUI国际化配置
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});

// 全局配置
Vue.prototype.$qs = qs;
Vue.prototype.$memberid = localStorage.getItem('memberid');
Vue.prototype.$uuid = localStorage.getItem('uuid');
//Vue.prototype.$Url = 'http://192.168.11.242:5883/';    //测试
Vue.prototype.$Url = 'https://exhibitor.apichina.com.cn/';    //正式
Vue.prototype.$language = 'cn';    //设置默认语言


Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})
// 防止按钮连点
Vue.directive('preventReClick', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 2000)
      }
    })
  }
})
// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.query.source) {
    localStorage.setItem('source', to.query.source)
  }
  //获取用户登录成功后储存的登录标志
  let getFlag = localStorage.getItem("Flag");
  let improve = localStorage.getItem("improve");
  let finishDataEdit = localStorage.getItem("finishDataEdit");

  //如果登录标志存在且为isLogin，即用户已登录
  if (getFlag === "isLogin") {
    //设置vuex登录状态为已登录
    store.state.isLogin = true;
    //如果已登录，还想想进入登录注册界面，则定向回首页
    if (to.meta.isImprove) {
      if (to.meta.isImprove && (improve === 'true' || improve === null) && finishDataEdit !== 'true') {
        next({ path: '/dataEdit' })
      } else {
        next()
      }
    } else {
      next()
    }
    //如果登录标志不存在，即未登录
  } else {
    console.log('未登陆')
    //用户想进入需要登录的页面，则定向回登录界面
    if (to.meta.isLogin) {
      next({ path: '/login' })
    } else {
      next()
    }
  }
});
router.afterEach(route => {
  window.scroll(0, 0);
});

//rem计算
function setRem() {
  var whdef = 100 / 750;// 表示1920的设计图,使用100PX的默认值
  var bodyWidth = document.body.clientWidth;// 当前窗口的宽度
  var rem = bodyWidth * whdef;// 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
  document.getElementsByTagName('html')[0].style.fontSize = rem + 'px';
}

if (document.body.clientWidth < 767) {
  window.addEventListener('load', setRem);
  // window.addEventListener('resize', setRem);
}

//应用初始化
new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app');
